<script lang="ts" setup>
const {collectionUri,pageUri} = useI18nCollection();
const page = await queryCollection(collectionUri('home')).path(pageUri('/home')).first();
</script>

<template>
  <div>
    <NuxtLayout name="page-with-banner" :page="page">
      <SectionIntro />
      <SectionServices />
    </NuxtLayout>
  </div>
</template>